var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { selectors, } from "paul-core-package";
import { PercentageBox } from "./PercentageBox";
import { Legend } from "./Legend";
import { Description } from "./Description";
import { getComparisonPercentage } from "../../../helpers/getComparisonPercentage";
var incompatibleDataMessageKey = "NO_DATA_MESSAGE";
export var ComparingTwoValuesInfo = function (_a) {
    var referenceValue = _a.referenceValue, focusValue = _a.focusValue, percentageTitle = _a.percentageTitle, referenceValueTitle = _a.referenceValueTitle, referenceValueUnit = _a.referenceValueUnit, focusValueTitle = _a.focusValueTitle, focusValueUnit = _a.focusValueUnit, description = _a.description, action = _a.action;
    var theme = useTheme();
    var tI = useSelector(selectors.getActiveTranslationsInterfaceUILocalizations);
    if (!referenceValue && !focusValue) {
        return null;
    }
    var isPositive = referenceValue && focusValue ? referenceValue >= focusValue : undefined;
    var comparisonPercentage = referenceValue && focusValue
        ? getComparisonPercentage(referenceValue, focusValue)
        : undefined;
    var isDataIncomplete = !referenceValue || !focusValue;
    return (_jsxs(Box, __assign({ sx: {
            display: "flex",
            flexDirection: "column",
            width: 185,
            height: "100%",
        } }, { children: [_jsx(PercentageBox, { comparisonPercentage: Number(comparisonPercentage), percentageTitle: percentageTitle, isPositive: isPositive }), _jsx(Legend, { referenceValueTitleColor: theme.palette.grey[500], referenceValueTitle: referenceValueTitle, referenceValueValue: referenceValue, referenceValueUnit: referenceValueUnit, focusValueTitleColor: isPositive || !referenceValue
                    ? theme.palette.primary.main
                    : theme.palette.warning.main, focusValueTitle: focusValueTitle, focusValueUnit: focusValueUnit, focusValueValue: focusValue, action: action }), description && (_jsxs(Box, __assign({ sx: { marginTop: "auto" } }, { children: [isDataIncomplete && (_jsx(Box, __assign({ mb: 2 }, { children: _jsx(Typography, __assign({ variant: "subtitle2", color: "text.secondary", sx: { wordBreak: "break-word" } }, { children: tI[incompatibleDataMessageKey] })) }))), _jsx(Description, { description: description, action: action })] })))] })));
};
